import axios from 'axios';
import { API_URL } from '../config';

const api = axios.create({
  baseURL: API_URL
});

// Добавляем интерцептор для обработки ошибок
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Если токен истек или недействителен, очищаем локальное хранилище
      localStorage.removeItem('token');
    }
    return Promise.reject(error);
  }
);

// Добавляем интерцептор для установки токена
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api; 